<p-toast position="bottom-right"></p-toast>

<p-confirmDialog key="dlg1" #cd [style]="{width: '600px'}">
  <p-footer>
    <button type="button" pButton accesskey="y" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Delete" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog key="dlg2">
</p-confirmDialog>

<!-- <div class="section-title">User Role Management</div> -->
<div style="height:100%;">
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>
      <span style="padding-top:2px;">
        <button pButton type="button" 
                class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
                icon="pi pi-fw pi-refresh" 
                (click)="loadRules()"></button>
  
        <!-- Display only on bigger than md screens-->
        <span class="p-d-none p-d-md-inline">
          <button pButton type="button" 
                  class="p-button p-button-text" 
                  label="Add Weekday Rule"
                  icon="far fa-calendar-alt fa-lg"
                  (click)="addRule(false)"></button>
  
          <button pButton type="button" 
                  class="p-button p-button-text" 
                  label="Add Weekend Rule"
                  icon="far fa-calendar fa-lg"
                  (click)="addRule(true)"></button>
  
          <button pButton type="button" 
                  class="p-button p-button-text" 
                  [disabled]="selectedRow === null"
                  label="Delete Selected Rule" 
                  icon="far fa-trash-alt fa-lg mr-1 text-warning"
                  (click)="deleteRule(selectedRow)"></button>  
        </span>
        <!-- Display only on smaller than md screens-->
        <span class="p-d-md-none">
          <button pButton type="button" 
                  class="p-button-rounded p-button-success" 
                  icon="pi-fw far fa-calendar-alt"
                  (click)="addRule(false)"></button>

          <button pButton type="button" 
                  class="p-button-rounded p-button-success" 
                  icon="pi-fw far fa-calendar"
                  (click)="addRule(true)"></button>
  
          <button pButton type="button" 
                  class="p-button-rounded p-button-success"  
                  [disabled]="selectedRow === null"
                  icon="far fa-trash-alt fa-lg"
                  (click)="deleteRule(selectedRow)"></button>  
        </span>
      </span>
    </div>
  
    <div class="p-toolbar-group-right">
      <i class="pi-fw fas fa-lock p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon text-danger" pBadge style="font-size: 1.7rem"
         severity="danger"
         pTooltip="Total Number of locked rules: {{getLockedCount()}} out of {{rules.length}}"
         tooltipPosition="left"
         value="{{getLockedCount()}}"></i>
  
      <i class="pi-fw fas fa-unlock p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge style="font-size: 1.7rem"
         severity="info"
         pTooltip="Total Number of unlocked rules: {{getUnlockedCount()}} out of {{rules.length}}"
         tooltipPosition="left"
         value="{{getUnlockedCount()}}"></i>
  
    </div>
  </p-toolbar>
  
  <div style="height: calc(100% - 36px); width:100%;">
    <ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
                 size="default"
                 color="#2f9cf2"
                 type="line-scale-pulse-out"
                 [name]="spinnerName"
                 [fullScreen]="false">

      <p style="color:white" >Loading rules... </p>
    </ngx-spinner>

    <ag-grid-angular
          style="width: 100%; height:100%;"
          class="ag-theme-alpine"
          [rowData]="rules"
          [columnDefs]="gridHeaders"
          [context]="context"
          [gridOptions]="gridOptions"
          rowSelection="single"
          (rowDoubleClicked)='onRowDblClicked($event)'
          [frameworkComponents]="frameworkComponents"
          (rowClicked)="onRowClicked($event)"
          (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>